import { DropdownOption, mapToDropdownOption } from "sprint-common-web";

import { OrdersAirline } from "../../common/types/OrdersAirline";

export const getUniqueSystemDropdownOptions = (
    airlines: OrdersAirline[],
    airlineIds: string[] = []
): DropdownOption[] => {
    const uniqueSystems = new Map<string, DropdownOption>();

    airlines
        .filter(({ id }) => airlineIds.includes(id))
        .forEach(({ systemPlatforms }) => {
            systemPlatforms.forEach(({ system }) => {
                if (!uniqueSystems.has(system.id)) {
                    uniqueSystems.set(system.id, mapToDropdownOption(system));
                }
            });
        });

    return Array.from(uniqueSystems.values());
};
